<template>
  <div>

    <div id="bg">
      <vue-particles
        :class="loginBg"
        :color="Color"
        :particleOpacity="0.7"
        :particlesNumber="100"
        shapeType="circle"
        :particleSize="4"
        linesColor="#8DD1FE"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
      >
      </vue-particles>
      <b-container
        class="bv-example-row container"
        style="padding: 0 10%; box-sizing: border-box"
      >
       
        <b-row  style="margin-top: 5vh">
          <b-input-group class="mt-3,Forminput">
            <b-form-input
              style="background-color: transparent; color: #333"
              v-model="inputFwm"
			  class="fw"
			  id = 'fw'
			  ref = 'myinput'
              :placeholder="
                bool ? 'Please enter a verification code' : '请输入防伪验证码'
              "
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-primary" @click="query(inputFwm)">{{
                bool ? "Query" : "查询"
              }}</b-button>
            </b-input-group-append>
          </b-input-group>
		  <div class="line">
			  <div id="ReturnResult" style="color:#43afde; font-size:16px;font-weight:bold;">请输入16位防伪码，感谢您对我公司的支持与信赖。</div>
		  </div>
        </b-row>
		
		
      </b-container>
    </div>

    <font></font>
  </div>
</template>

<script>
import $ from 'jquery'
import md5 from 'js-md5';
export default {
  data() {
    return {
			loginBg:"",
			Color:"#39AFFD",
      variantType: "",
      fwmClass: "",
      alertboll: false,
      bool: true,
      Status: "",
      flag: true, //输入框显示
      inputFwm: "", //输入框内容
      inputCode: "", //输入框内容
      spinner: false, //请求等待指示
      alertTitle: "",
      alertNum: "",
      ManualBool: false, //手动输入按钮
      Emsg: "",
      Cmsg: "",
	  parameterValue:""
    };
  },
 Created() {
  	
  },
  mounted(){
	  this.getcode()
	  this.getCodeFromURL() 
	 
  },
  beforeDestroy(){
	  
  },
  methods: {
	  
	  getcode(){
		  const currentURL = window.location.href;
		    
		    const urlParts = currentURL.split('=');
		    if (urlParts.length >= 2) {
		      const parameterValue = urlParts[1];
		      console.log(parameterValue); // 输出 URL 参数值
		      return parameterValue;
		    } else {
		      console.log("未找到参数值");
		      return null; // 返回 null 或其他适当的默认值
		    }
	  },
 getCodeFromURL(){
	  		  
			  
			  let codeParam = this.getcode()
			  console.log(codeParam,11);
			  if(codeParam){
				  const inputwrite = document.getElementById('fw')
				  if(inputwrite){
				  	inputwrite.value = codeParam || ""
				  }
				  this.inputFwm =codeParam || "";
				  
				  		  
				  			  let FwCode = this.inputFwm
				  			  let $Fw = $("Fw")
				  			  let $CheckResult = $("#ReturnResult");
				  			  
				  			  $CheckResult.html("");
				  			  console.log(FwCode);
				  			  if (FwCode.length == 0) {
				  			      $CheckResult.html("防伪码不能为空");
				  			      $Fw.focus();
				  			      return false;
				  			  }
				  			  else if (FwCode.length < 12) {
				  			      $CheckResult.html("防伪码长度不能少于12位");
				  			      $Fw.focus();
				  			      return false;
				  			  }
				  			  else if (FwCode.length > 28) {
				  			      $CheckResult.html("防伪码长度不能大于28位");
				  			      $Fw.focus();
				  			      return false;
				  			  }
				  			  
				  			  if(FwCode.startsWith('0')){
				  				   zero();
				  			  }else if(FwCode.startsWith('5')){
				  				  five()
				  			  }else if(FwCode.startsWith('1')){
								  onestart()
							  }
							  else{
				  				  $CheckResult.html("输入错误");
				  			  }
				  			
				  			function onestart(){
								console.log(1123);
								let fCode = FwCode.match(/\d+/)
								let key = "66WFrRWaKK"
								let sign = md5(fCode+key).toUpperCase()
								console.log(sign);
								
								$.ajax({
									url:"http://tyfwjk.ty-315.com/api/tyfw/QueryA?fwm="+fCode+"&code=LELZSHS27&sign="+sign+"&ip=192.168.0.28",
									type:"get",
									async:false,
									success:function(res){
										console.log(res);
										$CheckResult.html(res.ResultMsg);
									}
								})
							}
				  			function zero() {
				  			  function post(url,data)
				  			  {
				  			  	var xml;
				  			  	if(window.ActiveXObject){xml = new ActiveXObject("Microsoft.XMLHTTP")}
				  			  	else if(window.XMLHttpRequest){xml = new XMLHttpRequest()}
				  			  	xml.open ("POST", url, false, "", "");
				  			  	xml.setRequestHeader ("CONTENT-TYPE", "application/x-www-form-urlencoded");
				  			  	xml.send (data);
				  			  	return xml.responseText;
				  			  }
				  			  //=================================
				  			  		//post提交url
				  			  		//url=http://ling.315-china.com/static/ling/
				  			  		//---------------------------------
				  			  		//securitycode		防伪码---必须
				  			  		var str=post("http://ling.315-china.com/static/ling/","securitycode="+FwCode)
				  			  		//=================================
				  			  		//返回值
				  			  		//---------------------------------
				  			  		//state  防伪码状态  可通过state状态自定义回复内容
				  			  		//   -3  防伪码不存在
				  			  		//   -2  拉进黑名单防伪码
				  			  		//   -1  仓库未发货防伪码
				  			  		//    0  正确防伪码,无查询过
				  			  		//    >0  正确防伪码,多次查询次数
				  			  		//onceuser  第一次查询用户
				  			  		//oncedate  第一次查询日期
				  			  		let obj=eval("("+str+")")
				  			  		if(obj.state==-3){
				  						
				  						$CheckResult.html('警告！您查询的产品防伪码不存在，谨防假冒。');
				  			  			
				  			  		}
				  			  		if(obj.state==-2){
				  						$CheckResult.html('警告！您查询的产品已被拉进黑名单，谨防假冒，请核实授权信息。');
				  			  			
				  			  		}
				  			  		if(obj.state==-1){
				  						$CheckResult.html('您好！您所查询的产品防伪编码是'+FwCode+',为泉润官方正品，请放心使用，感谢您的查询！。');
				  			  			
				  			  		}
				  			  		if(obj.state==0){
				  						$CheckResult.html('您好！您所查询的产品防伪编码是'+FwCode+',为泉润官方正品，请放心使用，感谢您的查询！。');
				  						
				  			  			
				  			  		}
				  			  		if(obj.state>0){
				  						$CheckResult.html('您查询的防伪码为'+FwCode+'，该防伪码在'+obj.oncedate+'已被首次查询，谨防假冒。');
				  			  		}
				  			  
				  			}
				  			
				  			function five() {
				  			  console.log(5123);
				  			  $CheckResult.html("正在查询......");
				  			  $(this).attr("disabled", true);
				  			  
				  			  $.getJSON(
				  			          //"http://www.dy-315.cn/api/FwQueryAPI.ashx?jsoncallback=?",
				  			          "http://14.23.76.106/api/FwQueryApiDetail.ashx?jsoncallback=?",
				  			          { FwCode: FwCode },
				  			          function (data) {
				  			              $CheckResult.html(data.QueryResult);
				  			              setTimeout(btnEnabled, 5000);
				  			          });
				  			  function btnEnabled() {
				  			      $("#btnQuery").attr("disabled", false);
				  			  }
				  			}
				  
				  			
				  			
				  
			  }else{
				  console.log(123);
				  return
			  }
	  		  
	  },

	  
	  query(inputFwm){
			  
			  let FwCode = this.$refs.myinput.value 
			  console.log(FwCode);
			  let $Fw = $("Fw")
			  let $CheckResult = $("#ReturnResult");
			  console.log(FwCode,777);
			  $CheckResult.html("");
			  console.log(FwCode);
			  if (FwCode.length == 0) {
			      $CheckResult.html("防伪码不能为空");
			      $Fw.focus();
			      return false;
			  }
			  else if (FwCode.length < 12) {
			      $CheckResult.html("防伪码长度不能少于12位");
			      $Fw.focus();
			      return false;
			  }
			  else if (FwCode.length > 28) {
			      $CheckResult.html("防伪码长度不能大于28位");
			      $Fw.focus();
			      return false;
			  }
			  
			  if(FwCode.startsWith('0')){
				   zero();
			  }else if(FwCode.startsWith('5')){
				  five()
				  
			  }else if(FwCode.startsWith('1')){
				  onestart()
				  
			  }
			  else{
				  $CheckResult.html("输入错误");
			  }
			
			function onestart(){
				console.log(1123);
				let fCode = FwCode.match(/\d+/)
				let key = "66WFrRWaKK"
				let sign = md5(fCode+key).toUpperCase()
				console.log(sign);
				
				$.ajax({
					url:"http://tyfwjk.ty-315.com/api/tyfw/QueryA?fwm="+fCode+"&code=LELZSHS27&sign="+sign+"&ip=192.168.0.28",
					type:"get",
					async:false,
					success:function(res){
						console.log(res);
						$CheckResult.html(res.ResultMsg);
					}
				})
			}
			
			function zero() {
			  function post(url,data)
			  {
			  	var xml;
			  	if(window.ActiveXObject){xml = new ActiveXObject("Microsoft.XMLHTTP")}
			  	else if(window.XMLHttpRequest){xml = new XMLHttpRequest()}
			  	xml.open ("POST", url, false, "", "");
			  	xml.setRequestHeader ("CONTENT-TYPE", "application/x-www-form-urlencoded");
			  	xml.send (data);
			  	return xml.responseText;
			  }
			  //=================================
			  		//post提交url
			  		//url=http://ling.315-china.com/static/ling/
			  		//---------------------------------
			  		//securitycode		防伪码---必须
			  		var str=post("http://ling.315-china.com/static/ling/","securitycode="+FwCode)
			  		//=================================
			  		//返回值
			  		//---------------------------------
			  		//state  防伪码状态  可通过state状态自定义回复内容
			  		//   -3  防伪码不存在
			  		//   -2  拉进黑名单防伪码
			  		//   -1  仓库未发货防伪码
			  		//    0  正确防伪码,无查询过
			  		//    >0  正确防伪码,多次查询次数
			  		//onceuser  第一次查询用户
			  		//oncedate  第一次查询日期
			  		let obj=eval("("+str+")")
			  		if(obj.state==-3){
						
						$CheckResult.html('警告！您查询的产品防伪码不存在，谨防假冒。');
			  			
			  		}
			  		if(obj.state==-2){
						$CheckResult.html('警告！您查询的产品已被拉进黑名单，谨防假冒，请核实授权信息。');
			  			
			  		}
			  		if(obj.state==-1){
						$CheckResult.html('警告！您查询的产品未得到官方授权，谨防假冒，请核实授权信息。');
			  			
			  		}
			  		if(obj.state==0){
						$CheckResult.html('您好！您所查询的产品防伪编码是'+FwCode+',为泉润官方正品，请放心使用，感谢您的查询！。');
						
			  			
			  		}
			  		if(obj.state>0){
						$CheckResult.html('您查询的防伪码为'+FwCode+'，该防伪码在'+obj.oncedate+'已被首次查询，谨防假冒。');
			  		}
			  
			}
			
			function five() {
			  console.log(5123);
			  $CheckResult.html("正在查询......");
			  $(this).attr("disabled", true);
			  
			  $.getJSON(
			          //"http://www.dy-315.cn/api/FwQueryAPI.ashx?jsoncallback=?",
			          "http://14.23.76.106/api/FwQueryApiDetail.ashx?jsoncallback=?",
			          { FwCode: FwCode },
			          function (data) {
			              $CheckResult.html(data.QueryResult);
			              setTimeout(btnEnabled, 5000);
			          });
			  function btnEnabled() {
			      $("#btnQuery").attr("disabled", false);
			  }
			}

			
			
	  }
 
  },
};
</script>

<style lang="less" scoped>
#bg {
	width: 100%;
	min-height: calc(100vh - 200px);
	overflow-y: hidden;
}

.container {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
}
.header {
	position: fixed;
	top:0;
	width: 100%;
	z-index:9;
	box-sizing: border-box;
		line-height: 56px;
		height: 56px;
		padding: 0 14px;
		background-color: #b3c0d1;
	}
#fwmAlert {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  border-radius: 0.5rem;
  padding: 0.5rem;
  color: #222;
}

.fwmClassSuccess {
  /* background: #caeed2; */
  background-color: rgba(202, 238, 210, 0.8);
}

.fwmClassWarning {
  background: rgba(255, 229, 156, 0.8);
}

.fwmClassError {
  /* background: rgb(255, 152, 152); */

  background-color: rgba(255, 172, 172, 0.8);
  /* background-image: url("../assets/1.png");
	background-size: 100% 100%; */
}

.b-alert {
  opacity: 0.8;
  box-shadow: 0px 0px 1px 0.5px rgb(40, 40, 40) inset;
}

.spinner {
  position: absolute;
  left: 50%;
}

.scanCodeBtn {
  width: 48px;
  height: 48px;
  background-color: rgba(255, 255, 255, 0);
  border: none;
  margin: 5% auto;
  background-image: url(./image/SaoMa.png);
}
/* 查询结果文字 */
.msg{
	position: relative;
	top: 30%;
	left: 50%;
	transform: translate(-50%, -50%);
}
/* // 如果是全屏展示 */
.login-bg {
  width: 100%;
  height: 100%;
	background: rgb(255, 255, 255);
	/* background-image: url('./image/111.png'); */
	background-size: 100% 100%;
}
.login-bg2{
	width: 100%;
  height: 100vh;
	background: rgb(255, 255, 255);
	/* background-image: url(./image/222.png); */
	background-size: 100% 100%;
}

/* 修改输入框提示文字颜色 */
input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #fff;
}

input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #fff;
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #fff;
}
/* 修改输入框提示文字颜色 */
</style>
